import { render } from "./TvmSuggestions.vue?vue&type=template&id=2a63df28&scoped=true"
import script from "./TvmSuggestions.js?vue&type=script&lang=js&external"
export * from "./TvmSuggestions.js?vue&type=script&lang=js&external"

import "./TvmSuggestions.vue?vue&type=style&index=0&id=2a63df28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a63df28"],['__file',"src/Components/ChatWidget/TvmSuggestions/TvmSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a63df28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a63df28', __exports__)) {
    api.reload('2a63df28', __exports__)
  }
  
  module.hot.accept("./TvmSuggestions.vue?vue&type=template&id=2a63df28&scoped=true", () => {
    api.rerender('2a63df28', render)
  })

}


export default __exports__